import { type AxiosRequestConfig } from 'axios'

const getNotificationsCount = (): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: '/notifications/count'
  }
}

export { getNotificationsCount }
